module.exports = __webpack_public_path__ + "static/media/apply.ee3b587d.svg";